import React from 'react';
import { IconProps } from '.';

type CheckIconProps = {
  color?: string;
} & IconProps;

export const CheckIcon: React.FC<CheckIconProps> = ({
  height = 16,
  width = 16,
  color = '#787878',
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none"
      viewBox="0 0 16 16"
    >
      <path
        fill={color}
        d="M8 16c-4.4 0-8-3.6-8-8s3.6-8 8-8 8 3.6 8 8-3.6 8-8 8zM8 1C4.1 1 1 4.1 1 8s3.1 7 7 7 7-3.1 7-7-3.1-7-7-7z"
      ></path>
      <path
        fill={color}
        d="M7 11.3L3.4 7.8l.7-.7L7 9.9 11.9 5l.7.7L7 11.3z"
      ></path>
    </svg>
  );
};
